import React from "react";
import classes from './Input.module.scss';
import { Input as AntInput } from "antd";
import { useTranslation } from "react-i18next";

const PasswordInput = ({placeholder, ...props}, ref) => {
  const { t } = useTranslation();

  return (
    <AntInput.Password
      ref={ref}
      className={classes.input}
      placeholder={placeholder}
      {...props}
    />
  )
}

export default PasswordInput;
